import Alpine from 'alpinejs';

import accordion from "./alpine-components/accordion.js";
import dropdownMenu from "./alpine-components/dropdown-menu.js";
import customSelect from "./alpine-components/custom-select.js";
import tabs from "./alpine-components/tabs.js";
import popover from "./alpine-components/popover.js";
import contextMenu from "./alpine-components/context-menu.js";
import modal from "./alpine-components/modal.js";
import clickAnimation from "./alpine-components/click-animation.js";
import copyClipboard from "./alpine-components/copy-clipboard.js";

window.Alpine = Alpine;
customSelect(Alpine);
accordion(Alpine);
dropdownMenu(Alpine)
tabs(Alpine);
contextMenu(Alpine);
modal(Alpine);
popover(Alpine);
clickAnimation(Alpine);
copyClipboard(Alpine);
Alpine.start();